import React from "react";

const Description = () => {
  return (
    <div>
      <p className="description text-center">
        Minimal wage by County calculated in Deso
      </p>
    </div>
  );
};

export default Description;
